<template>
  <crud-table-controller :entity-type="DB_ENTITIES.THEME" />
</template>

<script>
import CrudTableController from "@/components/CrudTableController";
import { DB_ENTITIES } from "@/constants/common";
export default {
  components: { CrudTableController },
  computed: {
    DB_ENTITIES() {
      return DB_ENTITIES;
    },
  },
};
</script>

<style></style>
